export function browserId(): string {
  const key = 'sorteia:browserId';
  try {
    const existing = localStorage.getItem(key);
    if (existing) return existing;
    const id = 'brw_' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-6);
    localStorage.setItem(key, id);
    return id;
  } catch {
    return 'brw_ephemeral';
  }
}

export function clientHeaders(): HeadersInit {
  const userAgent = navigator.userAgent || '';
  const bridge = typeof window === 'undefined'
    ? undefined
    : (window as Window & { SorteiaNativePush?: { distributionCode?: () => string } }).SorteiaNativePush;
  const nativeAndroid = typeof bridge === 'object';
  const pwa = !nativeAndroid && typeof window !== 'undefined'
    && (window.matchMedia?.('(display-mode: standalone)').matches
      || (navigator as Navigator & { standalone?: boolean }).standalone === true);
  const deviceType = /Android/i.test(userAgent)
    ? 'android'
    : /iPhone|iPad|iPod/i.test(userAgent)
      ? 'ios'
      : /Mobi/i.test(userAgent)
        ? 'mobile'
        : 'desktop';

  const headers: Record<string, string> = {
    'X-Sorteia-Browser-Id': browserId(),
    'X-Sorteia-Client-Mode': nativeAndroid ? 'apk' : pwa ? 'pwa' : 'web',
    'X-Sorteia-Device-Type': deviceType,
  };
  try {
    const distributionCode = bridge?.distributionCode?.()?.trim();
    if (distributionCode) headers['X-Sorteia-Distribution-Code'] = distributionCode;
    const clickId = localStorage.getItem('sorteia:attributionClickId')?.trim();
    if (clickId) headers['X-Sorteia-Click-Id'] = clickId;
  } catch {
    // Ephemeral/private browsing may deny storage or a stale WebView bridge may throw.
  }
  return headers;
}
